export default __webpack_public_path__ + "static/media/0xd0258a3fd00f38aa8090dfee343f10a9d4d30d3f.c42231ba.webp";